import { XCircleIcon } from "@phosphor-icons/react/dist/csr/XCircle";
import { Alert, AlertDescription } from "@volca/ui/components/ui/alert";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type {
  PayrollStatementNotificationDelivery,
  PayrollStatementNotificationRecipient,
} from "./types";
import { getNotificationReasonLabel } from "./utils";

export const SendFailuresBanner = ({
  deliveries,
  recipients,
}: {
  deliveries: PayrollStatementNotificationDelivery[];
  recipients: PayrollStatementNotificationRecipient[];
}) => {
  if (deliveries.length === 0) return null;

  const recipientNames = new Map(
    recipients.map((recipient) => [recipient.technician_id, recipient.name]),
  );

  return (
    <Alert color="danger">
      <XCircleIcon />
      <AlertDescription>
        <Text variant="caption">Some PayPacks couldn't be sent.</Text>
        <Stack align="start" gap={1}>
          {deliveries.map((delivery, index) => {
            const key =
              delivery.delivery_id ??
              delivery.id ??
              `${delivery.technician_id ?? "unknown"}-${index}`;
            const recipientName = delivery.technician_id
              ? recipientNames.get(delivery.technician_id)
              : null;

            return (
              <Text key={key} tone="muted">
                {recipientName ??
                  delivery.recipient_email ??
                  "Unknown recipient"}
                : {getNotificationReasonLabel(delivery.error) ?? "Failed"}
              </Text>
            );
          })}
        </Stack>
      </AlertDescription>
    </Alert>
  );
};
